import mild from '../images/mildhigh.jpg'
import haunted from '../images/hauntedchild.jpg'
import ankara from '../images/express.jpg'
import both from '../images/both.jpg'
import dusk from '../images/duskwave.jpg'
import calming from '../images/calmingwaters.png'



const CardData = [
    {
        
        imagesource: mild,
        title: "Mild High Album",
        text: 'A 10-Tracked chilled and feel-good album with an aim to relax and enjoy sounds from different parts of the world blended in with a soothing tempo and instrumentation layering.',
        Spotify:'https://open.spotify.com/album/0hguS7vVQaPWQQJ7yFgzvS?si=Dte9gW2rSfqW-AYVXMb3rw',
        Apple:'https://music.apple.com/us/album/mild-high/1561062663',
    },
    {
        imagesource: haunted,
        title: "Haunted Child",
        text: 'Scary, Melodious and Dark, Haunted child is a fun-groovy danceable song categorized under the genre "Dark-synthwave" and it is meant for the halloween celebration to boost in the fun and the scare factor.',
        Spotify:'https://open.spotify.com/track/4gCPAd6ukMKQ8J7PY0LDE0?si=8534abdbce2c49fa',
        Apple:'https://music.apple.com/us/album/haunted-child-single/1587016016',    
    },
    {
        imagesource: ankara,
        title: "Ankara vol 1",
        text: 'A tribute to the Turkish city of Ankara associated with calmness, serenity, mental clarity, modernity and peace of mind The track hits all the jackpots in-blend of Lofi with modernity.',
        Spotify:'https://open.spotify.com/track/6EdXHYDnWbylEC0wioOQ2E?si=7f22c085f4e341a6',
        Apple:'https://music.apple.com/us/album/ankara-single/1671881688',
        
    },
    {
        imagesource: both,
        title: "Both",
        text: 'A summer full of dance and fun, full of energy and happiness, both is a song for having a good time enjoying once self either at a party or festival or personal space, its meant for being down for a good time and let loose of yourself.',
        Spotify:'https://open.spotify.com/track/6qdH5XJU2pB6vhHllxSCbN?si=bf35e60118b84fa7',
        Apple:'https://music.apple.com/us/album/both-feat-t%C3%A2yl%C3%B6r/1591499455?i=1591499457',
        
    },
    {
        imagesource: dusk,
        title: "Dusk Wave",
        text: 'A song that reflects a blend of a red-orange sky hue stretched across the ocean horizon during summer, its meant to show the spirit of fun and happinessas a family enjoying their time together and promotes a positiveness in life.',
        Spotify:'https://open.spotify.com/track/5kyVPQq8MBP2QpWMo7fuNi?si=84ff3736eb484b03',
        Apple:'https://music.apple.com/us/album/dusk-wave-extended/1485258640?i=1485258641',
        
    },
    {
        imagesource: calming,
        title: "Calming waters",
        text: 'The sound of water is described as a guide for the neuronal waves in our brains that allows us to experience a calming effect. A combination of water and white noise has been said to have positive psychological benefits.',
        Spotify:'https://open.spotify.com/track/4el83H4hMq5da4XPZXSQTF?si=626a56674818452e',
        Apple:'https://music.apple.com/us/album/calming-waters/1480737489?i=1480737490',
        
    },
    
];

export default CardData;